var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full pt-2"},[_c('div',{staticClass:"w-full flex flex-col"},[_c('InProgress')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }